const capitalise = (text: string) => text.charAt(0).toUpperCase() + text.slice(1)

/** A file name as a title: no extension, no save date, underscores as spaces. */
const documentTitle = (fileName: string) =>
  fileName
    .replace(/\.[^.]+$/, '')
    .replace(/_\d{4}-\d{2}-\d{2}$/, '')
    .replace(/_/g, ' ')

/** What the founder said it in, e.g. "email update", "Document · Kelpwise update" or "deck Seed Deck.pdf, version 2". */
export function sourceLabel(source: string): string {
  const deck = source.match(/^deck .*?, (version \d+)$/)
  if (deck) return `Pitch deck · ${deck[1]}`
  if (source.startsWith('deck ')) return 'Pitch deck'
  const file = source.match(/^document (.+)$/)?.[1]
  if (file) return `Document · ${documentTitle(file)}`
  return capitalise(source)
}
